module.exports = __webpack_public_path__ + "ef011d5523859ebb96f7b2e55cb49f6b.svg";